import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDateTime } from '../../../../utils/fmt';

const TenantList = () => {
  const columns = [
    { label: 'Company',    value: 'company_name' },
    { label: 'Tenant ID',  value: 'tenant_id' },
    { label: 'Status',     value: item => item.is_active ? 'Active' : 'Inactive' },
    { label: 'Last Sync',  value: (item) => fmtDateTime(item.last_sync) },
    { label: 'Created',    value: (item) => fmtDateTime(item.created_at) },
  ];

  return (
    <div>
      <h1>Tenant Management</h1>
      <ListTemplate
        columns={columns}
        fetchUrl={API_DOMAIN + API_ROUTES['tenantCredentials']}
      />
    </div>
  );
};

export default TenantList;
